import ModalShell from "./ModalShell";
export default function SuccessModal({ open, onClose, onViewResults }) {
  return (
    <ModalShell open={open} onClose={onClose} width={560}>
      <div
        className="p-5"
        style={{
          background: "linear-gradient(135deg, #0f8a4c 0%, #18b26b 100%)",
          color: "white",
        }}
      >
        <div className="d-flex align-items-center gap-2 fw-semibold">
          <span
            style={{
              width: 48,
              height: 48,
              borderRadius: 999,
              background: "rgba(255,255,255,0.2)",
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            ✓
          </span>
          <div>
            <div style={{ fontSize: 23 }}>Success</div>
            <div style={{ fontSize: 16, opacity: 0.9 }}>Submission Complete</div>
          </div>
        </div>
      </div>

      <div className="p-5 bg-white">
        <div className="fw-bold" style={{ fontSize: 26 }}>
          Your Results Are Ready
        </div>
        <div className="text-muted mt-1">Your personalized tax estimate is now unlocked.</div>

        <div className="mt-4 d-flex flex-column gap-3">
          <div className="border rounded-3 p-3" style={{ background: "#f7fbff" }}>
            <div className="d-flex align-items-start gap-2">
              <div className="shadow-lg p-2 d-flex align-items-center justify-content-center rounded-pill" style={{width:'30px', height:'30px', background:'white'}}>
                <span style={{ color: "#0f8a4c" }}>✉</span>
              </div>
              <div>
                <div className="fw-semibold">Email Sent</div>
                <div className="text-muted">
                  We’ve sent a copy of your results to your email so you can review them anytime.
                </div>
              </div>
            </div>
          </div>

          <div className="border rounded-3 p-3" style={{ background: "#f0fff6" }}>
            <div className="d-flex align-items-start gap-2">
              <div className="shadow-lg p-2 d-flex align-items-center justify-content-center rounded-pill" style={{width:'30px', height:'30px', background:'white'}}>
                <span style={{ color: "#0f8a4c" }}>📄</span>
              </div>
              <div>
                <div className="fw-semibold">Full Access Unlocked</div>
                <div className="text-muted">You can now view your full tax calculation on this page.</div>
              </div>
            </div>
          </div>
        </div>

        <button
          type="button"
          className="btn w-100 fw-semibold mt-4"
          onClick={onViewResults}
          style={{
            background: "#0f8a4c",
            borderColor: "#0f8a4c",
            color: "white",
            padding: "12px 14px",
            borderRadius: 12,
          }}
        >
          View My Results
        </button>
      </div>
    </ModalShell>
  );
}